export var TrustType;
(function (TrustType) {
    TrustType["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustType["DiscretionaryTrust"] = "DISCRETIONARY_TRUST";
    TrustType["Fixed"] = "FIXED";
    TrustType["Hybrid"] = "HYBRID";
    TrustType["Other"] = "OTHER";
    TrustType["SimpleOrBare"] = "SIMPLE_OR_BARE";
    TrustType["SuperannuationTrusts"] = "SUPERANNUATION_TRUSTS";
    TrustType["Unit"] = "UNIT";
})(TrustType || (TrustType = {}));
//# sourceMappingURL=TrustType.js.map